module.exports = __webpack_public_path__ + "4f4a5f80a97b4b537eb21b6a6eaf71a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website-logo-white.png
// module id = 257
// module chunks = 1